/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/apple_watch'
export default icon
